import { Box } from "@mui/material";

import {
  BlErrorMessage,
  type ErrorMessageProps,
} from "Shared/Inputs/ErrorMessage";
import { BlInputLabel, type InputLabelProps } from "Shared/Inputs/InputLabel";

interface InputWrapperProps {
  labelProps?: InputLabelProps;
  errorProps?: ErrorMessageProps;
  children: React.ReactNode;
}

export const InputWrapper = ({
  labelProps,
  errorProps,
  children,
}: InputWrapperProps): React.ReactNode => (
  <Box sx={{ display: "flex", flexDirection: "column" }}>
    {labelProps?.label && <BlInputLabel {...labelProps} />}
    {children}
    <BlErrorMessage {...(errorProps ?? {})} />
  </Box>
);
